import React from "react";
import {SortableHandle } from "react-sortable-hoc";
import Acl from "../../../../hoc/Acl";
import { isSet } from "../../../../utils/commonUtils";
import Icons from "../../Icons";

const DragHandler = ({value})=>{
    const {acl,iconType} = value;
   return(
        <td>
            <Acl acl={isSet(acl,'any')}>
                <RowHandler iconType={iconType}/>
            </Acl>
        </td>
    )
}
DragHandler.defaultProps ={
    changeHandler:()=>{},
    isSortable:false,
}

export default DragHandler;

const RowHandler = ({ iconType="Drag" }) => {
    const SortableIcon = SortableHandle(() => (
        <span className="handle" style={{ cursor: 'grab' }}>
            <Icons type={iconType} />
        </span>
    ));
    return <SortableIcon />;
};